function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPeaceSign = function SvgPeaceSign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 1c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zM9 3.1c-3.4.5-6 3.4-6 6.9 0 1.1.2 2.1.7 3L9 8.5V3.1zm0 13.8c-1.7-.2-3.2-1.1-4.2-2.3L9 11.1v5.8zm7.3-3.9c.4-.9.7-1.9.7-3 0-3.5-2.6-6.4-6-6.9v5.5l5.3 4.4zm-1.1 1.7c-1.1 1.2-2.6 2-4.2 2.3v-5.8l4.2 3.5z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgPeaceSign;